import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface RequestSubmittedEventProperties {
  path_flow_id?: string
  path_graph_flow_id?: string
  path_flow_slug: string
  request_id: string
  lead_id: string
  category_slug?: string
  city?: string
  email?: string
  first_name?: string
  last_name?: string
  phone?: string
  state?: string
  zip?: string
  /**
   * @deprecated Use category_slug instead (they are identical)
   */
  parent_category_slug?: string
  /**
   * @deprecated Use category_slug instead
   */
  content_category?: string
  /**
   * @deprecated Use path_flow_slug instead
   */
  experiment_variation?: string
}

export class RequestSubmittedEvent extends Event<RequestSubmittedEventProperties> {
  static displayName = 'Request Submitted'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
